import React from "react";
import Rellax from "rellax";
import { useDispatch, useSelector } from 'react-redux';
import PresentationHeader from "components/Headers/PresentationHeader2.js";
import CotizadorCore from "../components/Cotizador/CotizadorCore.js";
import logo from "../assets/img/Notaria/logo.jpg";
import { cargarNotaria } from '../actions/notariaAction';
import { apiService } from '../config.js';


function Cotizador() {
  const dispatch = useDispatch();
  const notaria = useSelector((state) => state.notaria.notaria);
  const [servicios, setServicios] = React.useState([]);

  React.useEffect(() => {
    const consultar = async () => {
      try {
        const resultado = await apiService.getNotaria();
        if (resultado.status === 200) {
        let dataTemp = {};
        resultado.data.forEach((element) => {
          dataTemp[element.variable] = String(element.value ?? "");
        });
        dispatch(cargarNotaria(dataTemp));
      }
      } catch (error) {
        console.error("Error notaria:", error.message);
      }
    };
    consultar();
  }, []);

  React.useEffect(() => {
    const consultarServicios = async () => {
      try {
        const resultado = await apiService.getConfigCotizador();
        setServicios(Array.isArray(resultado.data) ? resultado.data : []);
      } catch (error) {
        console.error("Error servicios:", error.message);
      }
    };
    consultarServicios();
  }, []);

  React.useEffect(() => {
    document.body.classList.add("presentation-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    if (window.innerWidth >= 991) {
      setTimeout(function () { new Rellax(".rellax", { center: true }); }, 5000);
      new Rellax(".rellax-header");
      new Rellax(".rellax-text");
    }
    let script = document.createElement("script");
    script.src = "https://buttons.github.io/buttons.js";
    script.id = "github-buttons-script-id";
    document.body.appendChild(script);
    return function cleanup() {
      document.body.classList.remove("tramites-page");
      document.body.classList.remove("sidebar-collapse");
      script.parentNode.removeChild(script);
    };
  }, []);

  return (
    <>
      <div className="wrapper">
        <PresentationHeader titulo="COTIZAR"/>
        <CotizadorCore
          onCotizar={apiService.cotizarPublico}
          serviciosIniciales={servicios}
          notaria={notaria}
          logoSrc={logo}
          title="COTIZADOR"
        />
      </div>
    </>
  );
}

export default Cotizador;